import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import actions from './actions'
import mutations from './mutations'
import menuItems from './menu-items'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  mutations,

  state: {
    // app
    appDrawer: null,
    stateless: false,
    menu: menuItems,
    loginDialog: false,
    filtersSidebar: false,
    group_required: false,
    selectedGroup: { 'id': null, 'description': 'New Group', 'visibility_type_id': 0, 'filers': [] },
    excludedGroup: { 'id': null, 'description': 'New Group', 'visibility_type_id': 0, 'filers': [] },
    selectedStockGroup: { 'id': null, 'description': 'New Group', 'visibility_type_id': 0, 'stocks': [] },
    excludedStockGroup: { 'id': null, 'description': 'New Group', 'visibility_type_id': 0, 'stocks': [] },
    show_whalescore_filers: false,
    show_funds_by_performance: false,
    show_heat_map_option: false,
    filer_performance: {
      selected: false,
      max_filers: 10,
      top_performing_type: null,
      turnover_type: null,
      top10_type: null,
      holdings_from_to: [5, 1000],
      mc_from_to: [100, 400000],
      use_holdings: true,
      use_mc: true,
      time_held_top10_from_to: [4, 8],
      use_time_held_top10: false,
      adv_insider_ownership: null
    },
    ws: null,
    heat_map: false,
    // init
    user: null,
    groups: [],
    insider_cluster_criteria: {
      transaction_type: 4,
      date_range: 1,
      owner_types: [5],
      minimum_unique_owners: '3',
      minimum_transaction_amount: '100000',
      industries: [],
      sectors: [],
      minimum_percent_ownership: '',
      avg_daily_volume_from: '',
      avg_daily_volume_to: '',
      exclude_public_offering: true,
      is_10b5: false,
      market_caps: [],
      minimum_transaction_count: '',
      stock_price_min: '',
      stock_price_max: '',
      avg_dollar_value_volume_min: '',
      avg_dollar_value_volume_max: '',
      buy_reversal: false,
      restrict_recent_52_week_high: false,
      restrict_recent_52_week_low: false
    },
    quarters: [],
    backtests: [],
    sectors: [],
    email_alerts: [],
    classifications: [],
    countries: [],
    sec_code_states: [],
    news: [],
    states: [],
    ww_groups: [],
    insider_alerts: [],
    insider_alerts_promise: null,
    ownershiptcodes: [],
    groups_promise: null,
    quarters_promise: null,
    backtests_promise: null,
    sectors_promise: null,
    email_alerts_promise: null,
    classifications_promise: null,
    countries_promise: null,
    sec_code_states_promise: null,
    states_promise: null,
    ww_groups_promise: null,
    ownershiptcodes_promise: null,

    // user specific
    limit: 5,
    is_team_member: false,
    is_subscriber: false,
    is_pro_subscriber: false,
    is_enterprise_subscriber: false
  },

  getters: {
    isSelectedFund: (state) => (fund) => {
      return state.selectedGroup.filers.some(selected => selected.id === fund.id)
    }
  }
})
